import React from 'react';
import { useSelector } from 'react-redux';
import Order from 'src/pages/home/component/orders/order/Order';
import { OrderContainer } from 'src/pages/home/component/orders/ordersCardView/OrdersCardView.styled';
import OrderDateCaseHeader from 'src/pages/home/component/orders/ordersDateCaseHeader/OrdersDateCaseHeader';
import { getShortMonthName, getFullDayName } from 'src/utils/dateUtils';

const OrdersSearchResults = ({ searchOrdersResult, openDetailsModal }) => {
    const content = [];
    const searchParam = useSelector((state) => state.filterReducer.searchParam);

    searchOrdersResult = (searchOrdersResult || []).map((order) => {
        return {
            ...order,
            surgeryStartDateAtMidnight: new Date(order.surgeryStartDate),
        };
    });
    const ordersHeaderContentHandler = (date) => {
        const dateObject = new Date(date);
        const fullDate =
            dateObject.getDate() +
            ' ' +
            getShortMonthName(dateObject.getMonth()) +
            ' ' +
            dateObject.getFullYear();
        const day = ' - ' + getFullDayName(dateObject.getDay());
        return (
            <OrderDateCaseHeader
                key={fullDate}
                selectedDate={dateObject}
                day={day}
                totalCase={
                    searchOrdersResult.filter(
                        (order) =>
                            new Date(
                                order.surgeryStartDateAtMidnight
                            ).toDateString() === date
                    ).length
                }
                isToday={date === new Date().toDateString()}
            />
        );
    };

    const contentHandler = (date) => {
        return (
            <OrderContainer key={date}>
                {searchOrdersResult
                    .filter(
                        (order) =>
                            new Date(
                                order.surgeryStartDateAtMidnight
                            ).toDateString() === date
                    )
                    .map((order) => {
                        return (
                            <Order
                                openDetailsModal={openDetailsModal}
                                key={order?.myCaseRef}
                                {...order}
                            />
                        );
                    })}
            </OrderContainer>
        );
    };

    if ((searchOrdersResult || []).length !== 0 && searchParam !== '') {
        let previousDate =
            searchOrdersResult[0].surgeryStartDateAtMidnight.toDateString();
        content.push(
            ordersHeaderContentHandler(new Date(previousDate).toDateString())
        );
        content.push(contentHandler(new Date(previousDate).toDateString()));

        let previousOrders = searchOrdersResult.filter(
            (order) =>
                new Date(order.surgeryStartDateAtMidnight).toDateString() ===
                new Date(previousDate).toDateString()
        );
        for (
            let i = previousOrders.length;
            i < searchOrdersResult.length;
            i++
        ) {
            if (
                previousDate !==
                new Date(
                    searchOrdersResult[i].surgeryStartDateAtMidnight
                ).toDateString()
            ) {
                content.push(
                    ordersHeaderContentHandler(
                        new Date(
                            searchOrdersResult[i].surgeryStartDateAtMidnight
                        ).toDateString()
                    )
                );
                content.push(
                    contentHandler(
                        new Date(
                            searchOrdersResult[i].surgeryStartDateAtMidnight
                        ).toDateString()
                    )
                );
            }
            previousDate = new Date(
                searchOrdersResult[i].surgeryStartDateAtMidnight
            ).toDateString();
        }
    }

    return content;
};

export default OrdersSearchResults;
